'use strict'

/**
 * Module qui gère les tooltips bootstrap
 */

/*
 * Fonction qui met en place un tooltip sur l'item passé en paramètre
 */
function setEventOnItem(item, position, label) {
    const option = {
        placement: position,
        title: label,
        trigger: 'manual'
    }
    $(item).tooltip(option)
    $(item).attr('data-original-title', label)
    $(item).tooltip('show')
}

function hideToolTip(item) {
    $(item).tooltip('hide')
}

export default {
    setEventOnItem: setEventOnItem,
    hideToolTip: hideToolTip
}
